// src/app/qr/page.tsx
import "./qr.scss"
import BarcodeScanner from "../../components/BarCodeScanner/BarCodeScanner";

const QRPage = () => {
  return (
    <div className="container">
      <BarcodeScanner />
    </div>
  );
};

export default QRPage;
